import { Carousel, Col, Row } from "react-bootstrap";
import { Sponsor } from "../../helpers/useSponsors";

interface Props {
    sponsors: Sponsor[];
}

export function SponsorBanner({ sponsors }: Props) {
    const groupsOfThree = sponsors.reduce((resultArray, item, index) => { 
        const chunkIndex = Math.floor(index/3)
        if(!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [] // start a new chunk
        }
        resultArray[chunkIndex].push(item)
        return resultArray
    }, new Array<Sponsor[]>())

    return (
        <Col className="sponsorBanner">
            <h3 style={{ fontSize: '20px', fontWeight: 700, color: 'var(--wpa-dark-blue)', marginBottom: '4px' }}>Our Partners</h3>
            <hr />
            <Carousel style={{height: '120px'}}> 
                {
                    groupsOfThree.map((group, index) => {
                        return (
                            <Carousel.Item key={index} className="px-5">
                                <Row className="justify-content-center">
                                    {
                                        group.map((sponsor) => {
                                            return (
                                                <Col key={sponsor.id} className="mb-2">
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                        <a href={sponsor.websiteUrl}>
                                                        <img style={{ height: '80px', width: '80px', display: 'block', objectFit: 'contain'}}
                                                            src={sponsor.logoUrl}
                                                            alt={sponsor.name}
                                                        />
                                                        </a>
                                                    </div>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </Carousel.Item>
                        )
                    })
                }
            </Carousel>
        </Col>
    )
}